export const firebaseConfig = {
    apiKey: "AIzaSyCmKdZAdHtInimko95ZU2RK9f1VKQduxoY",
    authDomain: "moviedb-a034b.firebaseapp.com",
    projectId: "moviedb-a034b",
    storageBucket: "moviedb-a034b.appspot.com",
    messagingSenderId: "331826806841",
    appId: "1:331826806841:web:4f89b4b4bd55fcfd544de8"
};
